<template>
    <v-expansion-panel class="client">
        <v-expansion-panel-header>
            <div>
                <v-avatar size="30">
                    <img :src="Member.member_photo_path" alt="">
                </v-avatar>
                {{Member.full_name}}
                <v-icon v-if="Member.attendance != null && Member.period_id != null" class="mr-2" small color="green"> mdi-check-circle-outline </v-icon>
            </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-row>
                <v-col class="ml-7" cols="8">
                    <label>{{ $page.props.lang.select_membership || "Select membership" }}</label>
                    <v-select
                        @change="setCurrentSubscription"
                        v-model="Member.period_id"
                        :items="Member.subscriptions"
                        :hint="currentSubscription != null ? currentSubscription.remaining : ''"
                        hide-no-data
                        hide-selected
                        persistent-hint
                        item-text="name"
                        item-value="period_id"
                        :error-messages="errors.period_id"
                        :hide-details="!errors.period_id"
                        @focus="errors.period_id=''"
                        dense outlined flat>
                    </v-select>
                </v-col>
            </v-row>
            <v-row class="mb-4">
                <v-col class="ml-7" cols="8">
                    <v-select v-model="Member.attendance"
                        :items="statusItems" 
                        item-text="title" 
                        item-value="value"
                        :error-messages="errors.status"
                        :hide-details="!errors.status"
                        @focus="errors.status=''" 
                        label="Status" 
                        class="status-select"
                        dense outlined solo flat height="26px">
                    </v-select>
                    <v-checkbox v-model="Member.apply_charge"
                        v-if="Member.attendance != 1"
                        label="Označi termin iskorištenim" 
                        hide-details>
                    </v-checkbox>
                </v-col>
            </v-row>
            <v-card-actions>
                <v-btn @click="openDeleteModal()" :id="'delete' + member.id" color="red" outlined fab small>
                   <v-icon>mdi-trash-can-outline</v-icon>
                   <v-tooltip :activator="'#delete'+ member.id" right open-delay="400">
                       <span>{{$page.props.lang.deleteMemberAttend || "Delete member from appointment"}}</span>
                   </v-tooltip>
                </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="saveMemberStatus()" 
                    color="primary" outlined>{{ $page.props.lang.save || "Save" }}</v-btn>
        </v-card-actions>
        <ReccuringModal :open="showDeleteAllModal"
        @no="removeMember(false)" 
        @yes="removeMember(true)"
        @close="showDeleteAllModal = false"
        :description="$page.props.lang.deleteFromAllConfirmDescription || 'Do You want to delete member only from this or this and all future events?'"
        :noText="$page.props.lang.deleteMemberConfirmNoText || 'Only from this'" 
        :yesText="$page.props.lang.deleteMemberConfirmYesText || 'This and from all future events'">
        </ReccuringModal>

        <ConfirmModal 
        :open="showDeleteModal" 
        @no="showDeleteModal = false" 
        @yes="removeMember(false)" 
        @close="showDeleteModal = false"
        :description="$page.props.lang.removeMemberConfirmDescription || 'Are You sure You want to remove member from this appointment?'">
        </ConfirmModal>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>
<script>
import EventBus from '@/js/eventbus'
import ConfirmModal from '@/js/Components/ConfirmModal'
import ReccuringModal from '@/js/Pages/Backoffice/Calendar/Components/ReccuringModal'
export default ({
    components: {
        ConfirmModal,
        ReccuringModal
    },
    props:{
        member: Object,
        appointment: Object
    },

    data(){
        return{ 
            Member: this.member,
            showDeleteModal: false,
            showDeleteAllModal:false,
            errors:[],
            statusItems: [
                { title: this.$page.props.lang.attended || 'Attended', value: 1},
                { title: this.$page.props.lang.canceled || 'Canceled', value: -1},
                { title: this.$page.props.lang.missing || 'Missing', value: 0}
            ],
            currentSubscription: null
        }
    },
   
    methods: {

        openDeleteModal(){
            if(this.appointment.parent_id != null || this.appointment.recurring === 1){
                this.showDeleteAllModal = true;
            }else{
                this.showDeleteModal = true;
            }
        },

        setCurrentSubscription(){
            this.currentSubscription = this.Member.subscriptions.find(i => i.period_id == this.Member.period_id)
        },

        saveMemberStatus() {

            var payload = {
                appointment_id: this.appointment.id,
                period_id: this.Member.period_id,
                subscription_id: this.currentSubscription.id,
                member_id: this.Member.id,
                status: this.Member.attendance,
                charge: this.Member.apply_charge
            }
            axios.post('/backoffice/home/make_attendance', payload)
            .then(response => {

                    var color = "error";
                    if(response.data.status==="OK") { 
                       color = 'success';
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: color,
                        timeout: 5000
                    });
                })
                 .catch(error => {

                     EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 5000
                    });

                    this.errors = error.response.data.errors
                });
        },

        removeMember(recurring){

            axios.post('/backoffice/calendar/appointment/removemember', {
                id: this.appointment.id,
                member_id: this.member.id,
                is_recurring: recurring,
                parent_id: this.appointment.parent_id
            }).then((r) => {
                if(r.data.status == "OK"){
                    this.showDeleteModal = false;
                    this.showDeleteAllModal = false;
                    EventBus.$emit('REMOVE_MEMBER_FROM_APPOINTMENT', {
                        id: this.member.id
                    });

                }else{

                }
            })

        }

    }
        
})
</script>
